<template>
  <div class="employee-teaser">
    <article class="employee-teaser">
      <div class="aspect-square">
        <img width="560" height="560" loading="lazy" :src="imageUrl" />
      </div>

      <h3
        class="title mt-size-6 is-size-5 belowTablet:mt-size-7 tablet:!text-size-5 desktop:!text-size-4"
      >
        {{ firstName }} {{ lastName }}
      </h3>
      <p
        class="subtitle mb-0 is-size-6 tablet:!text-size-6 desktop:!text-size-5"
      >
        <span>{{ subtitle }}</span>
      </p>
      <div
        class="employee-teaser-links mt-size-7 is-size-5 belowTablet:mt-size-7"
      >
        <NuxtLink
          v-if="contactUrl?.path"
          class="link is-grey with-icon"
          :to="contactUrl.path"
          title="E-Mail senden"
        >
          <SpriteSymbol name="email" />
        </NuxtLink>

        <a v-if="phoneLink" class="link is-grey" :href="phoneLink">
          <SpriteSymbol name="phone" />
        </a>

        <a
          v-if="xingLink"
          class="link is-grey with-icon"
          :href="xingLink"
          target="_blank"
        >
          <SpriteSymbol name="xing" />
        </a>
        <a
          v-if="linkedinLink"
          class="link is-grey with-icon"
          :href="linkedinLink"
          target="_blank"
        >
          <SpriteSymbol name="linkedin" />
        </a>

        <a
          v-if="twitterLink"
          class="link is-grey with-icon"
          :href="twitterLink"
          target="_blank"
        >
          <SpriteSymbol name="twitter" />
        </a>
      </div>
    </article>
  </div>
</template>

<script lang="ts" setup>
import { getImageStyleUrl, getBaseUrl } from '~/helpers/responsiveStyles'
import type { NodeEmployeeTeaserFragment } from '#graphql-operations'
import { notNullish } from '@vueuse/core'

const props = defineProps<NodeEmployeeTeaserFragment>()

const media = computed(() => props.portrait)

const imageUrl = computed(() => {
  const url = getBaseUrl(media.value?.fileUrl?.path)
  const hash = media.value?.changed?.toString() || ''
  if (url) {
    return getImageStyleUrl('employee_portrait', url, hash)
  }
  return ''
})

const subtitle = computed(() =>
  (props.position || [])
    .map((v) => v?.name)
    .filter(notNullish)
    .join(','),
)

const phoneLink = computed(() => (props.phone ? `tel:${props.phone}` : ''))

const xingLink = computed(() =>
  props.xing ? `https://www.xing.com/profile/${props.xing}` : '',
)

const linkedinLink = computed(() =>
  props.linkedin ? `https://www.linkedin.com/in/${props.linkedin}` : '',
)

const twitterLink = computed(() =>
  props.twitter ? `https://www.twitter.com/${props.twitter}` : '',
)
</script>
